import { arrayOf, shape } from 'prop-types'

import MenuSection from 'views/components/organisms/HeaderNew/MenuSection'

import { banners } from './consts'

import './Products.scss'

const Products = ({ menuLinks }) => (
  <MenuSection
    banners={banners}
    menuLinks={menuLinks}
    boxClasses="u-padding-small--right@small-tiny"
    cardClasses="l-col--4-of-12@medium u-position--relative"
    titleWrapperClasses="l-col--4-of-12@medium"
  />
)

Products.propTypes = {
  menuLinks: arrayOf(shape({})).isRequired,
}

Products.defaultProps = {}

export default Products
